import { render, staticRenderFns } from "./config_editor.vue?vue&type=template&id=6ac2360e&"
import script from "./config_editor.vue?vue&type=script&lang=js&"
export * from "./config_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ac2360e')) {
      api.createRecord('6ac2360e', component.options)
    } else {
      api.reload('6ac2360e', component.options)
    }
    module.hot.accept("./config_editor.vue?vue&type=template&id=6ac2360e&", function () {
      api.rerender('6ac2360e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/configurations/config_editor.vue"
export default component.exports